import PropTypes from 'prop-types';
import React from 'react';
import { Grid } from '@custom-components';
import { approvalConfigShape } from '../helperFunctions';
import ApprovalConfigTable from './ApprovalConfigTable';
import List from '../List';

function ApprovalConfigList(props) {
  const { config, loading, error, setModal, setOpenConfig } = props;
  const viewFilters = [{ id: '0' }];
  const cardComponent = () => {};
  const data = Array.isArray(config) ? config : [config];
  const errorMessage = error && error.message ? error.message : undefined;

  const noDataObj = {
    title: errorMessage ? 
      errorMessage.substring(errorMessage.indexOf(': ') + 1, errorMessage.indexOf('.') + 1).trimStart() 
      : 'No configurations',
    message: errorMessage ? 
      errorMessage.substring(errorMessage.indexOf('.') + 1).trimStart() 
      : 'No configurations have been created'
  };

  return (
    <Grid.ScreenClassRender
      render={(screenClass) => (
        <List
          data={data}
          loading={loading}
          screenClass={screenClass}
          tableComponent={ApprovalConfigTable}
          cardComponent={cardComponent}
          viewFilters={viewFilters}
          noDataObj={noDataObj}
          pagination={false}
          header={false}
          initialToggleValue="tableView"
          otherComponentProps={{ setModal, setOpenConfig }}
        />
      )}
    />
  );
}

ApprovalConfigList.propTypes = {
  config: approvalConfigShape.isRequired,
  loading: PropTypes.bool,
  error: PropTypes.shape({
    message: PropTypes.string
  }),
  setModal: PropTypes.func.isRequired,
  setOpenConfig: PropTypes.func.isRequired
};

ApprovalConfigList.defaultProps = {
  loading: true,
  error: null
};

export default ApprovalConfigList;
